export default {
  "widget.defaultTitle": "Chatta con noi",
  "widget.defaultSubtitle": "Siamo qui per aiutarti",
  "widget.defaultGreeting": "Ciao! Come possiamo aiutarti oggi?",
  "chat.close": "Chiudi chat",
  "chat.open": "Apri chat",
  "chat.expand": "Espandi chat",
  "chat.collapse": "Riduci chat",
  "chat.conversationEnded": "Questa conversazione è terminata",
  "chat.startNew": "Inizia Nuova Conversazione",
  "chat.poweredBy": "Offerto da",
  "chat.conversationClosed": "Conversazione Chiusa",
  "chat.aiLabel": "Assistente IA",
  "input.placeholder": "Scrivi un messaggio...",
  "input.send": "Invia messaggio",
  "error.sendFailed": "Impossibile inviare il messaggio. Riprova tra un momento.",
  "error.messageTooLong": "Il messaggio è troppo lungo. Accorcialo e riprova.",
  "chat.teamMember": "Un membro del team",
  "chat.agentJoined": "{name} è in chat",
  "chat.agentLeft": "{name} ha lasciato la chat",
  "chat.agentReturnedToAi":
    "{name} ha lasciato la chat. Ora stai di nuovo parlando con l'assistente IA.",
  "availability.open": "Aperto ora",
  "availability.backAt": "Di ritorno {when}",
  "availability.closed": "Non disponibili ora",
  "waiting.title": "In attesa di una persona",
  "waiting.typical": "Di solito risponde in {time}",
  "waiting.alerted": "Abbiamo avvisato il team.",
  "waiting.closed":
    "Il team torna {when}. Fino ad allora, l'assistente IA può continuare ad aiutarti.",
  "waiting.minutes": "~{n} min",
  "waiting.hours": "~{n} h",
  "contact.prompt":
    "Lascia la tua email e ti invieremo lì la risposta del team se sarai andato via.",
  "contact.label": "Email",
  "contact.placeholder": "tu@esempio.it",
  "contact.submit": "Avvisami",
  "contact.consent": "Useremo la tua email solo per rispondere a questa conversazione.",
  "contact.saved": "Grazie! Se sarai andato via quando il team risponde, ti invieremo un'email.",
  "contact.failed": "Impossibile salvare la tua email. Controllala e riprova.",
  "input.attach": "Allega una foto o un PDF",
  "error.fileTooLarge": "Il file è troppo grande. Foto e PDF fino a 10 MB.",
  "error.fileType": "Puoi inviare foto (JPG, PNG, GIF, WebP) o PDF.",
  "error.fileFailed": "Impossibile inviare il file. Prova con un altro.",
  "attachment.photo": "Foto",
  "attachment.file": "File",
  "attachment.sending": "Invio in corso...",
  "error.verificationFailed": "Non siamo riusciti a verificare il messaggio. Ricarica la pagina e riprova.",
  "challenge.label": "Controllo di sicurezza",
  "challenge.prompt": "Un rapido controllo di sicurezza prima di inviare il messaggio.",
  "csat.defaultQuestion": "Come valuteresti l'assistenza ricevuta oggi?",
  "csat.thankYou": "Grazie per il tuo feedback!",
} as const;
